"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Svg = _interopRequireDefault(require("./Svg"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Union = _interopRequireDefault(require("./Union"));
var _Down = _interopRequireDefault(require("./Down"));
var _Jump = _interopRequireDefault(require("./Jump"));
require("./mobile.scss");
var _getDataFormCid = require("../getDataFormCid");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ChangeData(val, num) {
  if (typeof val !== 'object') return true;
  return val === null || val === void 0 ? void 0 : val.map((item, index) => {
    const _ref = item || {},
      pane = _ref.pane;
    const _ref2 = pane || {},
      simpleData = _ref2.simpleData,
      iconsDesc = _ref2.iconsDesc;
    item.parentId = num || null;
    item.id = `${num ? `${num}_${index}` : index}`;
    if (simpleData) {
      pane.simpleData = ChangeData(simpleData, item.id);
    }
    if (iconsDesc) {
      pane.iconsDesc = ChangeData(iconsDesc, item.id);
    }
    if (item !== null && item !== void 0 && item.children) {
      item.children = ChangeData(item.children, item.id);
    }
    return item || {};
  });
}
function Mobile(props) {
  var _datas$;
  const setCurrentCid = props.setCurrentCid;
  const _ref3 = props || {},
    _ref3$configuration = _ref3.configuration,
    configuration = _ref3$configuration === void 0 ? [] : _ref3$configuration,
    _ref3$isFix = _ref3.isFix,
    isFix = _ref3$isFix === void 0 ? false : _ref3$isFix;
  const datas = ChangeData(configuration);
  const getOneTxt = (_datas$ = datas[0]) === null || _datas$ === void 0 ? void 0 : _datas$.label;
  const _useState = (0, _react.useState)(getOneTxt),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    title = _useState2[0],
    setTitle = _useState2[1];
  const _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    mainStatus = _useState4[0],
    setMainStatus = _useState4[1];
  return /*#__PURE__*/_react.default.createElement("section", null, /*#__PURE__*/_react.default.createElement("div", {
    className: 'm-navigation-title',
    onClick: () => {
      setMainStatus(!mainStatus);
    }
  }, /*#__PURE__*/_react.default.createElement("span", null, title), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      display: 'inline-flex'
    }
  }, mainStatus ? /*#__PURE__*/_react.default.createElement(_Union.default, null) : /*#__PURE__*/_react.default.createElement(_Down.default, null))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('navigation-content', {
      'navigation-hide': !mainStatus
    })
  }, /*#__PURE__*/_react.default.createElement(Tree, {
    configuration: datas,
    setMainStatus: setMainStatus,
    mainStatus: mainStatus,
    setTitle: setTitle,
    setCurrentCid: setCurrentCid,
    isFix: isFix,
    originalData: datas
  })));
}
function Tree(props) {
  const _ref4 = props || {},
    configuration = _ref4.configuration,
    setTitle = _ref4.setTitle,
    setCurrentCid = _ref4.setCurrentCid,
    _ref4$child = _ref4.child,
    child = _ref4$child === void 0 ? 0 : _ref4$child,
    setMainStatus = _ref4.setMainStatus,
    _ref4$isFix = _ref4.isFix,
    isFix = _ref4$isFix === void 0 ? false : _ref4$isFix,
    _ref4$originalData = _ref4.originalData,
    originalData = _ref4$originalData === void 0 ? [] : _ref4$originalData;
  const _useState5 = (0, _react.useState)({}),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    status = _useState6[0],
    setStatus = _useState6[1];
  const tabClick = item => {
    let ch = status;
    ch = _objectSpread(_objectSpread({}, ch), {}, {
      [item.id]: !ch[item.id]
    });
    setStatus(ch);
    setTitle(originalData[parseInt(item.parentId || item.id || 0)]['label'] || '');
    if (item.cid && (item.dataType === 'container' || item.parentId)) {
      isFix && window.scrollTo(0, 0);
      setMainStatus(false);
      setCurrentCid(item.cid);
    }
  };
  // children content click to tab
  const childClickToTabMobile = (tabIndex, cid) => {
    let item = {};
    (0, _getDataFormCid.find)(originalData, cid, function (obj) {
      item = obj;
    });
    const result = _objectSpread(_objectSpread({}, item), {}, {
      label: originalData[parseInt(tabIndex || 0)]['label']
    });
    tabClick(result);
  };
  if (typeof window !== 'undefined') {
    window.childClickToTabMobile = childClickToTabMobile;
  }
  return /*#__PURE__*/_react.default.createElement("span", {
    className: 'm-navigation-main-ul'
  }, configuration.map((item, index) => {
    const _ref5 = item || {},
      jump = _ref5.jump,
      label = _ref5.label,
      txt = _ref5.txt,
      desc = _ref5.desc,
      id = _ref5.id,
      pane = _ref5.pane,
      children = _ref5.children,
      dataType = _ref5.dataType,
      itemHref = _ref5.href;
    const _ref6 = jump || {},
      href = _ref6.href,
      icons = _ref6.icons;
    const resultHref = itemHref || href;
    const _ref7 = pane || {},
      simpleData = _ref7.simpleData,
      iconsDesc = _ref7.iconsDesc;
    const _data = simpleData || iconsDesc || children || [];
    return /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)(`main-ul__li`, {
        'main-ul__li--show ': !status[id],
        [`h_${desc ? 1 : 0}`]: !status[id]
      }),
      key: index
    }, resultHref ? /*#__PURE__*/_react.default.createElement("a", {
      href: resultHref,
      className: `layers d${child}`
    }, /*#__PURE__*/_react.default.createElement("span", {
      style: {
        display: 'flex',
        alignItems: 'center'
      }
    }, resultHref ? /*#__PURE__*/_react.default.createElement("a", {
      href: resultHref
    }, label || txt) : /*#__PURE__*/_react.default.createElement("span", null, label || txt), /*#__PURE__*/_react.default.createElement("span", {
      style: {
        position: 'relative',
        left: '16px'
      }
    }, icons ? /*#__PURE__*/_react.default.createElement(_Jump.default, {
      opacity: '0.8',
      color: 'white'
    }) : null), desc ? /*#__PURE__*/_react.default.createElement("span", {
      className: 'desc'
    }, desc) : null), /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)('rotate-svg-init', {
        'rotate-svg': !status[id]
      })
    }, _data !== null && _data !== void 0 && _data.length ? /*#__PURE__*/_react.default.createElement(_Svg.default, null) : null)) : /*#__PURE__*/_react.default.createElement("span", {
      className: `layers d${child}`,
      onClick: () => {
        tabClick(item);
      }
    }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", null, label || txt), desc ? /*#__PURE__*/_react.default.createElement("span", {
      className: 'desc'
    }, desc) : null), /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)('rotate-svg-init', {
        'rotate-svg': !status[id]
      })
    }, _data !== null && _data !== void 0 && _data.length ? /*#__PURE__*/_react.default.createElement(_Svg.default, null) : null)), _data !== null && _data !== void 0 && _data.length ? /*#__PURE__*/_react.default.createElement(Tree, {
      setMainStatus: setMainStatus,
      configuration: _data,
      child: child + 1,
      setCurrentCid: setCurrentCid,
      setTitle: setTitle,
      isFix: isFix,
      originalData: originalData
    }) : null);
  }));
}
var _default = exports.default = Mobile;